import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#register_trainee",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, "Bill Reset ")
  ])
], -1)
const _hoisted_3 = {
  id: "register_trainee",
  class: "collapse show"
}
const _hoisted_4 = { class: "collapse show" }
const _hoisted_5 = { class: "card-body border-top p-5" }
const _hoisted_6 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-2" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Tranche", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = { class: "col-md-3" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Training Partner", -1)
const _hoisted_13 = { class: "col-md-2" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Claims", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_16 = { class: "col-md-3" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Contract", -1)
const _hoisted_18 = { class: "col-md-2 mt-2" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-search" }, null, -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#batch_detail",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" })
], -1)
const _hoisted_21 = {
  id: "batch_detail",
  class: "collapse show"
}
const _hoisted_22 = { class: "collapse show" }
const _hoisted_23 = { class: "card-body border-top p-5" }
const _hoisted_24 = { class: "pt-0" }
const _hoisted_25 = { class: "m-0 sticky" }
const _hoisted_26 = { class: "table table-bordered table-row-bordered table-row-gray-400 align-middle border border-gray-400 gs-2 gy-3" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("thead", { style: {"border-left":"1.5px solid #23ce10"} }, [
  /*#__PURE__*/_createElementVNode("tr", { class: "bg-light fw-bolder fs-7 text-uppercase align-middle text-black" }, [
    /*#__PURE__*/_createElementVNode("th", null, "SI"),
    /*#__PURE__*/_createElementVNode("th", null, "Training Partner"),
    /*#__PURE__*/_createElementVNode("th", null, "Contract Name "),
    /*#__PURE__*/_createElementVNode("th", null, "Bill"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "Action")
  ])
], -1)
const _hoisted_28 = { style: {} }
const _hoisted_29 = { class: "text-start" }
const _hoisted_30 = { class: "text-start" }
const _hoisted_31 = { class: "text-start" }
const _hoisted_32 = { class: "text-start" }
const _hoisted_33 = {
  key: 0,
  style: {"color":"red"},
  class: "text-center"
}
const _hoisted_34 = {
  key: 1,
  class: "text-center"
}
const _hoisted_35 = ["onClick"]
const _hoisted_36 = /*#__PURE__*/_createElementVNode("span", { class: "text-light" }, "Reset", -1)
const _hoisted_37 = [
  _hoisted_36
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _hoisted_9,
                  _hoisted_10,
                  _createVNode(_component_el_select, {
                    class: "form-select-solid",
                    placeholder: "Select Tranche",
                    modelValue: _ctx.bill.tranche_id,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.bill.tranche_id) = $event)),
                    style: {"width":"100%"}
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tranches, (trans) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: trans.id,
                          label: trans.label,
                          value: trans.id
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(trans.label), 1)
                          ]),
                          _: 2
                        }, 1032, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _hoisted_12,
                  _createVNode(_component_el_select, {
                    class: "form-select-solid",
                    placeholder: "Select Partner",
                    modelValue: _ctx.bill.entity_id,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.bill.entity_id) = $event)),
                    filterable: "",
                    style: {"width":"100%"},
                    onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.getEntityContract()))
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.entityInfos, (data) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: data.id,
                          label: data.entity_short_name,
                          value: data.id
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("[" + _toDisplayString(data.entity_short_name) + "]-" + _toDisplayString(data.entity_name), 1)
                          ]),
                          _: 2
                        }, 1032, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _hoisted_14,
                  _hoisted_15,
                  _createVNode(_component_el_select, {
                    class: "form-select-solid",
                    placeholder: "Select Claim-No",
                    modelValue: _ctx.bill.claim_no,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.bill.claim_no) = $event)),
                    filterable: "",
                    style: {"width":"100%"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_option, {
                        label: "Claim-1",
                        value: "1"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Claim-1")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_option, {
                        label: "Claim-2",
                        value: "2"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Claim-2")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_option, {
                        label: "Claim-3",
                        value: "3"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Claim-3")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _hoisted_17,
                  _createVNode(_component_el_select, {
                    class: "form-select-solid",
                    placeholder: "Select Contract",
                    modelValue: _ctx.bill.entity_contract_id,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.bill.entity_contract_id) = $event)),
                    filterable: "",
                    style: {"width":"100%"}
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contractInfos, (data) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: data.id,
                          label: data.contract_name,
                          value: data.id
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(data.contract_name), 1)
                          ]),
                          _: 2
                        }, 1032, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("button", {
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.getAllBillNo())),
                    type: "submit",
                    class: "btn btn-success p-3 mt-6",
                    style: {"padding-top":"8px !important","padding-bottom":"8px !important"}
                  }, [
                    _createTextVNode(" Search "),
                    _hoisted_19
                  ])
                ])
              ])
            ])
          ])
        ])
      ])), [
        [_directive_loading, _ctx.loading]
      ])
    ]),
    (_ctx.showBillList)
      ? _withDirectives((_openBlock(), _createElementBlock("div", {
          class: "card mb-5 mb-xl-10",
          key: _ctx.componentKey
        }, [
          _hoisted_20,
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("table", _hoisted_26, [
                      _hoisted_27,
                      _createElementVNode("tbody", _hoisted_28, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.allBillNo, (info, key) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: key,
                            class: "border border-gray-400 text-center"
                          }, [
                            _createElementVNode("td", _hoisted_29, _toDisplayString(key+1), 1),
                            _createElementVNode("td", _hoisted_30, " [" + _toDisplayString(info?.bill_data?.entity_info?.entity_short_name) + "] - " + _toDisplayString(info?.bill_data?.entity_info?.entity_name), 1),
                            _createElementVNode("td", _hoisted_31, _toDisplayString(info?.bill_data?.contract_info?.contract_name), 1),
                            _createElementVNode("td", _hoisted_32, _toDisplayString(info?.bill_data?.bill_no), 1),
                            (info?.hasData?.length > 0)
                              ? (_openBlock(), _createElementBlock("td", _hoisted_33, " Please Reset " + _toDisplayString(info?.hasData?.[0]?.bill_no) + " First ", 1))
                              : _createCommentVNode("", true),
                            (info?.hasData?.length == 0)
                              ? (_openBlock(), _createElementBlock("td", _hoisted_34, [
                                  _createElementVNode("button", {
                                    onClick: ($event: any) => (_ctx.Reset(info?.bill_data?.bill_sequence_no)),
                                    title: "Reset",
                                    class: "btn btn-danger btn-sm"
                                  }, _hoisted_37, 8, _hoisted_35)
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128))
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])), [
          [_directive_loading, _ctx.load]
        ])
      : _createCommentVNode("", true)
  ], 64))
}